import normalizeReportFinanceCommisionTmHotelReconciliation from '/src/data/response/normalizeReportFinanceCommisionTmHotelReconciliation.js';
import { storeConstants } from '@utils/constants';
import factory from '@helpers/storeFactories/factory';

import { apiServiceTMHotelReconciliation } from '@api';

const STORE_NAME = 'TmHotelReconciliation';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServiceTMHotelReconciliation.tmHotelReconciliation.get,
    },
    {
        actions: {
            delete: true,
            select: true,
        },
        actionsOptions: {
            get: {
                defaultOptions: {
                    refresh: false,
                    offset: 0,
                    limit: 99,
                },
                controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
            },
        },
        normalizeItemFn: normalizeReportFinanceCommisionTmHotelReconciliation,
    },
    {
        getters: {
            isMultiSelected: (state, getters) => () => {
                return getters.getAllSelected().length > 1;
            },
        },
    }
);

export default store;
